import axiosInstance from '../../../Utils/axiosInstance';
import { PnlOperationConfig, PnlRunResponse } from './pnlOperations.types';

export const runPnlOperation = async (
  config: PnlOperationConfig,
  pnlDate: string, // YYYY-MM-DD
): Promise<PnlRunResponse> => {
  if (!config.endpoint) {
    throw new Error(`${config.title}: API not configured yet`);
  }
  // Postman shows no query params; add date only if backend supports it.
  const { data } = await axiosInstance.get<PnlRunResponse>(config.endpoint, {
    params: { date: pnlDate }, // remove if backend ignores/rejects
    timeout: 0,               // runs can take minutes
  });
  return data;
};

export const formatDuration = (ms: number): string => {
  const s = Math.floor(ms / 1000);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
};

// Backend returns "... completed for 3557 trades in 5.47 seconds."
export const parseRecords = (r: PnlRunResponse): number | undefined =>
  r.updated !== undefined ? r.updated : undefined;

